import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';
import { useIsLoggedInQuery } from './useGetIsLoggedInQuery';

/**
 * React Query hook to fetch enabled features for the authenticated user's tenant
 * Returns an array of feature keys (e.g., ['PSYCHOLOGICAL_SAFETY', 'CUSTOM_SURVEYS'])
 *
 * Note: This query is only enabled when the user is logged in
 * Uses isLoggedIn check instead of userInfo to avoid unnecessary refetches
 */
export const useTenantFeaturesQuery = () => {
  const { fetchTenantFeatures } = useServicesContext();
  const { data: isLoggedInData } = useIsLoggedInQuery();

  return useQuery({
    queryKey: ['GET_TENANT_FEATURES', 'current-user'],
    queryFn: fetchTenantFeatures,
    enabled: !!isLoggedInData?.isLoggedIn, // Only fetch when user is logged in
    staleTime: 5 * 60 * 1000, // 5 minutes - features don't change often
    gcTime: 10 * 60 * 1000, // 10 minutes cache time
  });
};
